import CustomerList from "./manageUsers/userList";
import CustomerTopbar from "./manageUsers/topbar";
import manageproducts from "../pages/productManagement/manageProducts";
import ManageInventory from "../pages/productManagement/manageInventory";
import addProduct from "../pages/productManagement/addProduct";
import ViewProduct from "../pages/productManagement/viewProduct";

/* eslint-disable import/no-anonymous-default-export */
export default {CustomerTopbar, CustomerList,manageproducts,ManageInventory,addProduct,ViewProduct};